import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2;
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/** @jsx jsx */
import EditorDoneIcon from '@atlaskit/icon/glyph/editor/done';
import { N900, N0, N50 } from '@atlaskit/theme/colors';
import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl-next';
import { css, jsx } from '@emotion/react';
import { ANALYTICS_HOVER_DELAY } from '../constants';
import { messages } from '../i18n';
var buttonStyles = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  height: 24px;\n  width: 24px;\n  background: ", ";\n  padding: 0;\n  border-radius: 4px;\n  border: 1px solid ", ";\n  cursor: pointer;\n  display: block;\n  box-sizing: border-box;\n  overflow: hidden;\n"])), "var(--ds-background-neutral, ".concat(N900, ")"), "var(--ds-border, ".concat(N0, ")"));
var buttonWrapperStyles = css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  border: 1px solid transparent;\n  margin: 0 2px;\n  font-size: 0;\n  display: flex;\n  align-items: center;\n  padding: 1px;\n  border-radius: 6px;\n  &:hover {\n    border: 1px solid ", ";\n  }\n"])), "var(--ds-border, ".concat(N50, ")"));
var Color = /*#__PURE__*/function (_PureComponent) {
  _inherits(Color, _PureComponent);
  var _super = _createSuper(Color);
  function Color() {
    var _this;
    _classCallCheck(this, Color);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "hoverStartTime", 0);
    _defineProperty(_assertThisInitialized(_this), "onMouseEnter", function () {
      _this.hoverStartTime = Date.now();
    });
    _defineProperty(_assertThisInitialized(_this), "onMouseLeave", function () {
      var onHover = _this.props.onHover;
      var delay = Date.now() - _this.hoverStartTime;
      if (delay >= ANALYTICS_HOVER_DELAY && onHover) {
        onHover(_this.props.value);
      }
      _this.hoverStartTime = 0;
    });
    _defineProperty(_assertThisInitialized(_this), "onMouseDown", function (e) {
      e.preventDefault();
    });
    _defineProperty(_assertThisInitialized(_this), "onClick", function (e) {
      var _this$props = _this.props,
        onClick = _this$props.onClick,
        value = _this$props.value;
      e.preventDefault();
      onClick(value);
    });
    return _this;
  }
  _createClass(Color, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        tabIndex = _this$props2.tabIndex,
        backgroundColor = _this$props2.backgroundColor,
        isSelected = _this$props2.isSelected,
        borderColor = _this$props2.borderColor,
        iconColor = _this$props2.iconColor,
        value = _this$props2.value,
        setRef = _this$props2.setRef;
      return jsx("span", {
        css: buttonWrapperStyles
      }, jsx(FormattedMessage, messages["".concat(value, "Color")], function (labels) {
        return jsx("button", {
          css: buttonStyles,
          onClick: _this2.onClick,
          onMouseEnter: _this2.onMouseEnter,
          onMouseLeave: _this2.onMouseLeave,
          onMouseDown: _this2.onMouseDown,
          tabIndex: tabIndex,
          className: "".concat(isSelected ? 'selected' : ''),
          title: labels[0]
          // button element does not support aria-selected.
          // For button selected (to be precise pressed) or not
          //  use aria-pressed as per
          // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/button_role#associated_aria_roles_states_and_properties
          ,
          "aria-pressed": isSelected,
          style: {
            backgroundColor: backgroundColor || 'transparent',
            borderColor: borderColor
          },
          ref: setRef
        }, isSelected && jsx(EditorDoneIcon, {
          primaryColor: iconColor,
          label: labels[0]
        }));
      }));
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.hoverStartTime = 0;
    }
  }]);
  return Color;
}(PureComponent);
export { Color as default };